// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version Aand command lines
// MODFIED DATE : 05-09-2025

// /* eslint-disable eslint-comments/disable-enable-pair */

import PartnerDetailsActionTypes from './partner-details.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	addBusinessPartnerResponse: null,
	fetchBusinessPartnerResponse: null,
	fetchBusinessPartnerList: [],
	updateBusinessPartnerResponse: null,
	deleteBusinessPartnerResponse: null,
};

// BUSINESS PARTNER DETAILS REDUCER FUCNTION - START
const businessPartnerDetailsReducer: any = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** ADD BUSINESS PARTNER START *********************** */
		case PartnerDetailsActionTypes.ADD_BUSINESS_PARTNER_SUCCESS:
			return { ...state, addBusinessPartnerResponse: action.payload };

		case PartnerDetailsActionTypes.ADD_BUSINESS_PARTNER_FAILURE:
			return { ...state, addBusinessPartnerResponse: action.payload };

		case PartnerDetailsActionTypes.ADD_BUSINESS_PARTNER_RESPONSE_CHANGED:
			return { ...state, addBusinessPartnerResponse: null };
		/** ***************** ADD BUSINESS PARTNER END *********************** */

		/** ***************** UPDATE BUSINESS PARTNER START *********************** */
		case PartnerDetailsActionTypes.UPDATE_BUSINESS_PARTNER_SUCCESS:
			return { ...state, updateBusinessPartnerResponse: action.payload };

		case PartnerDetailsActionTypes.UPDATE_BUSINESS_PARTNER_FAILURE:
			return { ...state, updateBusinessPartnerResponse: action.payload };

		case PartnerDetailsActionTypes.UPDATE_BUSINESS_PARTNER_RESPONSE_CHANGED:
			return { ...state, updateBusinessPartnerResponse: null };
		/** ***************** UPDATE BUSINESS PARTNER END *********************** */

		/** ***************** FETCH BUSINESS PARTNER START *********************** */
		case PartnerDetailsActionTypes.FETCH_BUSINESS_PARTNER_SUCCESS:
			return {
				...state,
				fetchBusinessPartnerResponse: action.payload,
				fetchBusinessPartnerList: docodeHexResponse(
					action.payload,
					'GetBusinessPartnerKey',
				),
			};

		case PartnerDetailsActionTypes.FETCH_BUSINESS_PARTNER_FAILURE:
			return { ...state, fetchBusinessPartnerResponse: action.payload };

		case PartnerDetailsActionTypes.FETCH_BUSINESS_PARTNER_RESPONSE_CHANGED:
			return { ...state, fetchBusinessPartnerResponse: null };
		/** ***************** FETCH BUSINESS PARTNER END *********************** */

		/** ***************** DELETE BUSINESS PARTNER START *********************** */
		case PartnerDetailsActionTypes.DELETE_BUSINESS_PARTNER_SUCCESS:
			return { ...state, deleteBusinessPartnerResponse: action.payload };

		case PartnerDetailsActionTypes.DELETE_BUSINESS_PARTNER_FAILURE:
			return { ...state, deleteBusinessPartnerResponse: action.payload };

		case PartnerDetailsActionTypes.DELETE_BUSINESS_PARTNER_RESPONSE_CHANGED:
			return { ...state, deleteBusinessPartnerResponse: null };
		/** ***************** DELETE BUSINESS PARTNER END *********************** */
		default:
			return state;
	}
};
// BUSINESS PARTNER DETAILS REDUCER FUNCTION -END
export default businessPartnerDetailsReducer;
